import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import BootstrapButton from "./BootstrapButton.jsx";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    backgroundColor: "rgba(10, 10, 10, 0.4)",
  },
  "& .MuiPaper-root": {
    borderRadius: "10px",
    maxWidth: "542px",
    // width: "520px",
  },
  "& .MuiDialogContent-root": {
    padding: "20px !important",
    color: "#4A4D52",
  },
  "& .MuiDialogActions-root": {
    padding: "20px",
    justifyContent: "center",
    borderTop: "solid 1px #E5E7EB",
  },
  "& .MuiDialogTitle-root": {
    padding: "27px 20px",
    fontSize: "18px",
    fontWeight: 500,
    color: "white",
    backgroundColor: "#7787f7",
  },
}));

const Modal = ({
  open,
  onClose,
  title,
  content,
  action,
  footer,
  styles = {},
}) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          ...styles,
        },
      }}
    >
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>{title}</Box>
          <Box sx={{ fontWeight: "bold", cursor: "pointer" }} onClick={onClose}>
            X
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent className="report-modal">{content}</DialogContent>
      <DialogActions>
        {footer ? (
          footer
        ) : (
          <BootstrapButton onClick={() => action.onClick && action.onClick()}>
            {action.label}
          </BootstrapButton>
        )}
      </DialogActions>
    </BootstrapDialog>
  );
};

export default Modal;
